import { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

async function fetchServiceDisruptionSummary(queryString) {
  const url = `${QUALITY_SERVICE_API_URL}/hub/service-disruption/summary${queryString ? `?${queryString}` : ''}`;
  console.log('[useServiceDisruptionSummary] Fetching from:', url);
  try {
    const response = await api.get(url);
    console.log('[useServiceDisruptionSummary] Success:', response.data);
    return response.data;
  } catch (err) {
    console.error('[useServiceDisruptionSummary] Error:', {
      status: err.response?.status,
      statusText: err.response?.statusText,
      data: err.response?.data,
      message: err.message,
    });
    throw err;
  }
}

function useServiceDisruptionSummary(filters, dateRange) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const params = new URLSearchParams();
  ['domain', 'group', 'unit'].forEach(key => {
    (filters?.[key] || []).forEach(value => params.append(key, value));
  });
  const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  if (dateRange?.startDate) params.set('from', formatDate(dateRange.startDate));
  if (dateRange?.endDate) params.set('to', formatDate(dateRange.endDate));
  const queryString = params.toString();

  const fetchSummary = useCallback(async (isCancelled = () => false) => {
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const summary = await fetchServiceDisruptionSummary(queryString);
      if (!isCancelled()) setData(summary);
    } catch (err) {
      if (!isCancelled()) setError(err);
    } finally {
      if (!isCancelled()) setLoading(false);
    }
  }, [queryString]);

  useEffect(() => {
    let cancelled = false;
    fetchSummary(() => cancelled);
    return () => { cancelled = true; };
  }, [fetchSummary]);

  return { data, loading, error, refetch: () => fetchSummary() };
}

export default useServiceDisruptionSummary;
